import type { AllRouteEndpoints } from "../routeTypes";

export const engagementAppGroupIdBannerTemplatesId = "/engagement/:app_group_id/banner_templates/:id";

export const engagementAppGroupIdBannerTemplatesIdCacheKeys: AllRouteEndpoints[] = [
  "/engagement/:app_group_id/banner_templates",
  "/engagement/:app_group_id/banner_templates/:id",
];
